import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AppdataService } from '../../../../service/appdata.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { InstructionsComponent } from '../instructions/instructions.component';

@Component({
  selector: 'app-basic-idea',
  standalone: false,
  templateUrl: './basic-idea.component.html',
  styleUrl: './basic-idea.component.scss'
})
export class BasicIdeaComponent implements AfterViewInit {
  thisStepCount: number = 0;
  totalStepCount: number = 0;
  progress: number = 0;
  nextStreamStepDisabledStatus: boolean = true;
  saveStreamStepDisabledStatus: boolean = true;
  stepId: any;
  streamId: any;

  activeStep: number = 1

  stream: any;
  step: any

  problemFormCOntrol: any;
  userFormCOntrol: any;
  solutionFormCOntrol: any;

  constructor(
    private appData: AppdataService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private instructionsDialog: MatDialog
  ) {
    route.queryParams.subscribe(async (params) => {
      this.stepId = await params['stepId'];
      this.streamId = await params['streamId'];
    });

    appData.tracks.subscribe(async (data) => {
      for await (const track of data) {
        for await (const stream of track.streams) {
          if (stream.id === this.streamId) {
            this.stream = stream;
            this.step = await stream.steps.find((step: any) => step.id === this.stepId);

            this.totalStepCount = stream.steps.length;
            this.thisStepCount = this.step.orderNr

            let pro = this.thisStepCount / this.totalStepCount;
            this.progress = pro * 100;
          }
        }
      }
    });

    this.problemFormCOntrol = this.fb.control('');
    this.userFormCOntrol = this.fb.control('');
    this.solutionFormCOntrol = this.fb.control('');

  }

  ngAfterViewInit(): void {
    // Load initPrompt if StepType has initPrompt
  }

  async nextStep() {
    this.activeStep += 1
  }
  async setStep(step: number) {
    if (step > this.activeStep) return;
    this.activeStep = step;
  }

  async openInstructions() {
    let dia = await this.instructionsDialog.open(InstructionsComponent, {
      data: {for: 'basicIdea'},
      width: '500px' 
    });
  
    dia.afterClosed().subscribe((result) => {})
  }

}
